import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-video-how-to',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatIcon,
  ],
  templateUrl: './video-how-to.component.html',
  styleUrl: './video-how-to.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoHowToComponent {
  dialogRef = inject<MatDialogRef<VideoHowToComponent>>(MatDialogRef);
}
